import React, { useState, useEffect } from "react"

function appendScript(baseUrl: string, setScriptLoaded: React.Dispatch<React.SetStateAction<boolean>>) {
  if (window.MktoForms2) return setScriptLoaded(true)

  const script = document.createElement("script")
  script.src = `${baseUrl}/js/forms2/js/forms2.min.js`
  script.onload = () => (window.MktoForms2 ? setScriptLoaded(true) : null)
  document.body.appendChild(script)
}

interface useMarketoProps {
  baseUrl: string
  munchkinId: string
  formId: string
}

function useMarketo({ baseUrl, munchkinId, formId }: useMarketoProps) {
  const [scriptLoaded, setScriptLoaded] = useState(false)

  useEffect(() => {
    if (scriptLoaded) {
      window.MktoForms2.loadForm(baseUrl, munchkinId, formId)
      return
    }
    appendScript(baseUrl, setScriptLoaded)
  }, [scriptLoaded, baseUrl, munchkinId, formId])
}

function LeadForm() {
  useMarketo({
    baseUrl: "//019-BFG-127.mktoweb.com",
    munchkinId: "019-BFG-127",
    formId: "2883",
  })

  return <form id="mktoForm_2883" />
}

export default LeadForm
